export type ColumnFilters = Record<string, string[]>;

export const MATRIX_GRANTED = 'granted';
export const MATRIX_DENIED = 'denied';

export const MATRIX_GRANT_FILTER_OPTIONS = [
  { value: MATRIX_GRANTED, label: 'Granted (X)' },
  { value: MATRIX_DENIED, label: 'Not granted' },
] as const;

export const USER_NO_PERMISSIONS = '(none)';

/**
 * Empty selection matches all values.
 */
export function matchesSetFilter(cellValue: string, selected: string[] | undefined): boolean {
  if (!selected || selected.length === 0) {
    return true;
  }
  return selected.includes(cellValue);
}

/**
 * For multi-value cells: row matches when any cell value is in the selection.
 */
export function matchesAnySetFilter(
  cellValues: string[],
  selected: string[] | undefined,
): boolean {
  if (!selected || selected.length === 0) {
    return true;
  }
  if (cellValues.length === 0) {
    return selected.includes(USER_NO_PERMISSIONS);
  }
  return cellValues.some((value) => selected.includes(value));
}

export function matrixGrantFilterValue(granted: boolean): string {
  return granted ? MATRIX_GRANTED : MATRIX_DENIED;
}

export function uniqueSorted(values: string[]): string[] {
  return Array.from(new Set(values)).sort((a, b) => a.localeCompare(b));
}

export function hasActiveColumnFilters(filters: ColumnFilters): boolean {
  return Object.values(filters).some((selected) => selected.length > 0);
}
